import { Maturity } from '@/services/graphQL/api/generated/types_web';

export enum MaturityLevels {
  ADULT = 'ADULT',
  TEEN = 'TEEN',
  OLDER_KID = 'OLDER_KID',
  YOUNGER_KID = 'YOUNGER_KID',
  PRE_SCHOOL = 'PRE_SCHOOL',
}

// Forward mapping: RTE -> UM
export const RTEToUMMaturityENUMMap: Record<Maturity, MaturityLevels> = {
  [Maturity.Adult]: MaturityLevels.ADULT,
  [Maturity.KidO]: MaturityLevels.OLDER_KID,
  [Maturity.KidPre]: MaturityLevels.PRE_SCHOOL,
  [Maturity.KidY]: MaturityLevels.YOUNGER_KID,
  [Maturity.Teen]: MaturityLevels.TEEN,
};

// Reverse mapping: UM -> RTE
export const UMToRTEMaturityENUMMap: Record<MaturityLevels, Maturity> = {
  [MaturityLevels.ADULT]: Maturity.Adult,
  [MaturityLevels.TEEN]: Maturity.Teen,
  [MaturityLevels.OLDER_KID]: Maturity.KidO,
  [MaturityLevels.YOUNGER_KID]: Maturity.KidY,
  [MaturityLevels.PRE_SCHOOL]: Maturity.KidPre,
};

export function RTE_To_UM_MaturityMap(m: Maturity): MaturityLevels {
  return RTEToUMMaturityENUMMap[m];
}

export function UM_To_RTE_MaturityMap(level: MaturityLevels): Maturity {
  return UMToRTEMaturityENUMMap[level];
}
